import { ValidatorFn } from '@angular/forms';
import { TemplateRef } from '@angular/core';

import { BulkEditVehiclesService } from './bulk-edit-vehicles.service';
import { BulkEditAssetsService } from './bulk-edit-assets.service';
import { BulkEditDriversService } from './bulk-edit-drivers.service';

export const CHANNEL_NAME = 'bulk-update';

export enum BULK_EDIT_ENTITY {
  DRIVERS = 'drivers',
  VEHICLES = 'vehicles',
  ASSETS = 'assets',
  GEOFENCES = 'geofences',
}

export enum PUSHER_EVENTS {
  ENTITY = 'geofence',
  PROGRESS = 'progress',
}

export enum ENTITY_TYPE {
  ASSET = 'asset',
  DRIVER = 'driver',
  VEHICLE = 'vehicle',
  FLEET_USER = 'fleet_user',
}

export enum BULK_EDIT_STATUS {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

export enum PUSHER_UPDATE_STATUS {
  UPDATING = 'updating',
  UPDATED = 'updated',
  FAILED = 'failed',
}
export type SelectedEntities = { [key: number]: boolean };

export interface IBulkEditsUpdateProgress {
  progress: number;
  done: boolean;
  total: number;
  failed_ids: number[];
  update_type: string;
}

export interface IServerRequest {
  filters?: IServerDriversFiltersRequest | IServerAssetsFiltersRequest | IServerVehiclesFiltersRequest;
  all_drivers?: boolean;
  all_assets?: boolean;
  all_vehicles?: boolean;
  excluded_ids?: number[];
  ids?: number[];
}
export interface IBulkEditRouteParams {
  count: number;
  entities: number[];
  selected_all: boolean;
  filters: string;
}

export interface IServerAssetsFiltersRequest {
  name?: string;
  status?: string;
  group_ids?: number[];
  gateway_identifier?: string;
  source?: string;
}

export interface IServerDriversFiltersRequest {
  name?: string;
  status?: string;
  group_ids?: number[];
  time_tracking_mode?: string;
}
export interface IServerVehiclesFiltersRequest {
  number?: number;
  status?: string;
  eld_identifier?: string;
  group_ids?: number[];
  defect_status?: string;
  with_aux_issues?: string;
  source?: string;
}

export interface IServerGeofencesFiltersRequest {
  name?: string;
  status?: string;
  categories?: string[];
}

export interface ICommonBulkEditSettings {
  add_group_ids?: number[];
  remove_group_ids?: number[];
  status?: BULK_EDIT_STATUS;
}

export interface IServerVehiclesSettingRequest extends ICommonBulkEditSettings {
  metric_units?: boolean;
  v2_inspection_form_id?: number;
  wifi_hotspot_data_threshold?: number;
  ifta?: boolean;
  prevent_auto_odometer_entry?: boolean;
  personal_conveyance_enabled?: boolean;
  sleeper_berth_availability?: boolean;
  use_truck_speed_limit?: boolean;
  is_long_idling_settings_configured?: boolean;
  long_idling_threshold_mins?: number;
}

export interface IServerAssetsSettingRequest extends ICommonBulkEditSettings {
  unpowered_mode_update_frequency?: number;
  is_unpowered_mode_update_frequency_configured?: boolean;
  location_update_frequency?: number;
}

export interface IServerDriversSettingRequest extends ICommonBulkEditSettings {
  time_zone?: string;
  metric_units?: boolean;
  yard_moves_enabled?: boolean;
  personal_conveyance_enabled?: boolean;
  manual_drive_time_enabled?: boolean;
}

type FormType = 'select' | 'checkbox' | 'radio' | 'input-group' | 'multi-tag';

export enum SETTING_FORM_TYPE {
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  INPUT_GROUP = 'input-group',
  MULTI_TAG = 'multi-tag',
}

export interface IMessageTemplates {
  updating: TemplateRef<any>,
  updated: TemplateRef<any>,
  updateFailed: TemplateRef<any>
}

export interface IBulkEditAdminSettingItem {
  [key: string]: {
    selected: boolean,
    title: string,
    category: string,
    subTitle?: string,
    selectedSettingTitle?: string,
    placeholder?: string,
    formType?: FormType,
    options?: Array<{ label: string, value: string | number | boolean }>
    validations: ValidatorFn[],
    validationError: Array<{ type: string, msg: string }>
    subForm?: {
      key: string,
      title: string,
      targetValue: string,
      formType: FormType,
      options?: Array<{ label: string, value: string | number }>
      validations?: ValidatorFn[],
      validationError?: Array<{ type: string, msg: string }>,
    },
  };
}

export interface ITag {
  id: number;
  label: string;
  size: string;
  tagType: string;
  contrast: string;
  suffixIcon: string;
}

export type BulkEditEntityService =
  BulkEditVehiclesService |
  BulkEditAssetsService |
  BulkEditDriversService;
export type IServerEntityFiltersRequest =
  IServerVehiclesFiltersRequest |
  IServerAssetsFiltersRequest |
  IServerDriversFiltersRequest;
export type IServerEntitySettingRequest =
  IServerVehiclesSettingRequest |
  IServerAssetsSettingRequest |
  IServerAssetsSettingRequest;